module.exports = __webpack_public_path__ + "media/עיר.2574ae9e.mp3";